<header id="header" [ngClass]="{'header' : 'header-scroll'}">
  <!-- <div class="loaderContent" *ngIf="loaderService.isLoading | async">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div> -->
  <div class="container">
    <div class="headerContent">
      <div class="logoHerader">
        <img routerLink="/" src="assets/belairtrip_assets/main/belairtrip.svg" alt="belairtrip.com - Book Cheap Flight Tickets" matTooltip="belairtrip.com - Book Cheap Flight Tickets" matTooltipClass="matTooltipClass" class="img-fluid"></div>
      <div class="main_nav" *ngIf="!COPT.isCorporateUser()">
        <nav>
          <ng-container *ngFor="let item of navItems">
            <button mat-button routerLink="/" [disabled]="item.isDisabled" [matTooltip]="item.title" matTooltipClass="matTooltipClass" class="active"> <!--[routerLink]="item.path" routerLinkActive="active"-->
                <div class="navIcon">
                    <img [src]="'assets/main/'+ item.icon" class="img-fluid lightIcon">
                    <img [src]="'assets/main/'+ item.iconDark" class="img-fluid darkIcon">
                </div>
                <span>{{item.title}}</span>
            </button>
          </ng-container>
        </nav>
      </div>
      <div class="spacer"></div>
      <ng-container *ngIf="COPT.isCorporateUser()">
        <ng-container *ngIf="isLoggedIn">
        <div class="hraderSupport copt_amount">
          <p [ngStyle]="{ color: balance === 0 ? 'red' : 'inherit' }">Total Balance: <span>{{ balance  * this.X_change.getCurrency().rate | globalCurrency: this.X_change.getCurrency().shortname | corporateBalance}}</span></p>
        </div>
        </ng-container>
      </ng-container>
      <!-- Cheapticket Currancy -->
      <div class="hraderSupport currencyMenu" *ngIf="showCurrency">
        <mat-accordion color="primary" [matMenuTriggerFor]="currencyMenu">
          <span class="d-flex pointer">
            <ng-container>&nbsp;&nbsp;{{this.currencySelected?.shortname}}&nbsp;&nbsp;({{this.currencySelected?.symbol}})</ng-container>
            <mat-icon>expand_more</mat-icon>
          </span>
        </mat-accordion>
        <mat-menu #currencyMenu>
          <ng-container *ngFor="let item of currency">
            <button mat-menu-item (click)="select(item)">
              <mat-icon color="primary">{{item?.symbol}}</mat-icon>
              <span>{{item?.name | titlecase}}({{item?.shortname}})</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
      <!-- Support -->
      <div class="hraderSupport d-none d-sm-block">
        <mat-accordion color="primary" [matMenuTriggerFor]="supportMenu">
          <div class="contacticon">
            <img src="../../../../assets/belairtrip_assets/main/female-services-support-icon.png" alt="Belairtrip.com Support" class="img-fluid">
            <span  class="d-flex pointer">Help <mat-icon>expand_more</mat-icon></span>
          </div>
        </mat-accordion>
        <mat-menu #supportMenu="matMenu" xPosition="before">
          <a mat-menu-item href="mailto:support@belairtrip.com">
            <mat-icon color="primary">email</mat-icon>
            <span>support&#64;belairtrip.com</span>
          </a>
          <!-- <a mat-menu-item href="tel:+91-9015776677">
            <mat-icon color="primary">call</mat-icon>
            <span>+91-9015776677 <span style="font-size: 12px;">(10AM - 7PM)</span></span>
          </a> -->
          <a mat-menu-item class="teleicon" href="tel:+91-9355019962">
            <img src="../../../../assets/belairtrip_assets/main/female-services-support-icon.png" alt="Belairtrip.com Support" class="img-fluid">
            <span>+91-9355019962 <span style="font-size: 12px;">(10AM - 7PM)</span></span>
          </a>
        </mat-menu>
      </div>
      <ng-container *ngIf="!isLoggedIn"> <!--&& !hideLoginButton-->
        <!-- <img class="profileImg" src="" alt=""> -->
        <div class="d-flex">
          <div class="logincircle" *ngIf="!COPT.isCorporateUser()">
            <img class="logincircle" src="../../../assets/belairtrip_assets/main/login-bt.png" alt="Login">
          </div>
          <button mat-button class="strokedRounded d-none d-sm-block" color="primary" (click)="signIn()">{{ COPT.isCorporateUser() ? 'Sign Up' : 'Log In / Sign Up' }}</button>
        </div>
      </ng-container>
      <!-- <button mat-button class="strokedRounded" color="primary" routerLink="/">Sign Up</button> -->
      <ng-container *ngIf="isLoggedIn">
        <div class="headerSupportProfile ml-3">
          <div class="profile" [matMenuTriggerFor]="profileMenu">
            <div class="profileImg">
              <div class="circle">
                <ng-template #noImage>
                  <span class="Initials">{{util.getUser() | slice:0:1 | titlecase}}</span>
                </ng-template>
                <img mat-image *ngIf="profile_image(); else noImage" [src]="profile_image() | removeHttp" class="img-fluid headerProfileImg"/>
              </div>
            </div>
            <div class="welcomespan">
              <span>Hi, {{util.getUser() | titlecase}}</span>
              <span class="welcometxt">Welcome to Belairtrip  <br> your ultimate travel companion!</span>
            </div>
          </div>
          <mat-menu #profileMenu="matMenu" xPosition="before">
            <ng-container *ngFor="let item of profileItems  | corporateFilter:COPT.isCorporateUser()">
              <button mat-menu-item [routerLink]="item.path" routerLinkActive="active" class="profileMenuButton">
                <mat-icon color="primary">{{item.icon}}</mat-icon>
                <div class="content">
                  <span>{{item.label}}</span><br>
                  <p class="descrip">{{item.content}}</p>
                </div>
              </button>
            </ng-container>
            <button mat-menu-item (click)="logOut()">
              <mat-icon color="primary">logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
      </ng-container>
    </div>
  </div>
</header>
